<template>
  <div>
    <main>
      <div id="HomeContainer" v-bind:style="{ backgroundImage: 'url(' + require('@/assets/images/content-bg.jpg') + ')' }">
          <div class="ContentAligher">

            <div class="row">
              <div class="col-md-5 col-md-offset-7">
                  <div id="HeroTitle">
                    <h1 class="bold">Contact Us</h1>
                    <p>Need support? In our commitment to excellence and safety, we remain ready to support to you from the start of your project, right up to its  completion.</p>
                    <a class="link" v-on:click="scrollMeTo('LogoList');">Get in touch.</a>
                  </div>
              </div>
            </div>

          </div>
      </div>
    </main>
    <section class="ContentAligher SectionSpacing T_alignCenter" ref="LogoList">
      <h3>725 E 98th street | Brooklyn, NY 11236</h3>
      <p>Tel. (718) 497-6001 | Fax: (718) 497-6003</p>
      <p>Email: <a href="mailto:office@elevinteriors.com">office@elevinteriors.com</a></p>
    </section>
  

    <rwv-general-form></rwv-general-form>
  </div>
</template>
<script>

//import RwvSubscribe from '@/components/Subscribe'
import * as $ from 'jquery'
import Vue from 'vue';
import VeeValidate from 'vee-validate';


import axios from 'axios'
import { API_BASE_URL } from '../config'
import { BASE_URL } from '../config'

Vue.use(VeeValidate);


import '@/assets/js/lightslider'

import RwvGeneralForm from '@/components/GeneralForm';
import RwvOurClients from '@/components/OurClients';


export default{
  name: 'ContactUs',
  components: {
    RwvGeneralForm, 
    RwvOurClients
  },
  data: function() {
    return {
     base_path: BASE_URL,
     finishes_list: [],
     testimonials:[]
    }
  },
  mounted() {
      $(".parallax").inertiaScroll({  parent: $("#SiteWrapper")  });
  },
  updated(){
     //$(".parallax").inertiaScroll({  parent: $("#SiteWrapper")  });
     setTimeout(function() {
          $(this).trigger('resize');
      }, 100);
  },
  methods: {
    scrollMeTo(refName) {
        
        var element = this.$refs[refName];
        var top = element.offsetTop;

        window.scrollTo(0, top);
    }
  },
  computed: {
  }
  
}

</script>
<style>
@import './../assets/css/lightslider.css';
</style>


// WEBPACK FOOTER //
// src/views/ContactUs.vue